export default __webpack_public_path__ + "static/media/bathroom1-after.7fcb4719.jpg";